import React, { useState, useRef } from "react";
import { Line, Bar } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const dummyLedger = [
  { date: "01 Feb", amount: 1200 },
  { date: "05 Feb", amount: 1800 },
  { date: "10 Feb", amount: 1500 },
  { date: "15 Feb", amount: 2200 }
];

export default function UdyamTrustHome() {
  const [activeTab, setActiveTab] = useState("Ledger");
  const pdfRef = useRef();

  const downloadPDF = async () => {
    const canvas = await html2canvas(pdfRef.current);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    pdf.addImage(imgData, "PNG", 10, 10, 190, 0);
    pdf.save("UdyamTrust_Report.pdf");
  };

  const chartData = {
    labels: dummyLedger.map(d => d.date),
    datasets: [
      {
        label: "Daily Transactions",
        data: dummyLedger.map(d => d.amount),
        borderWidth: 2
      }
    ]
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "Ledger":
        return (
          <>
            <h3 className="text-lg font-semibold mb-2">
              <i className="fas fa-book mr-2"></i>UdyamTrust Ledger
            </h3>
            <Line data={chartData} />
          </>
        );
      case "Proof":
        return (
          <>
            <h3 className="text-lg font-semibold mb-2">
              <i className="fas fa-certificate mr-2"></i>UdyamTrust Proof
            </h3>
            <Bar data={chartData} />
          </>
        );
      case "Family":
        return (
          <div className="grid grid-cols-2 gap-3">
            <div className="p-3 border rounded">
              <i className="fas fa-users"></i>
              <p className="mt-2 text-sm">Joint Savings</p>
            </div>
            <div className="p-3 border rounded">
              <i className="fas fa-heart"></i>
              <p className="mt-2 text-sm">Emergency Access</p>
            </div>
          </div>
        );
      case "Community":
        return (
          <div className="grid grid-cols-2 gap-3">
            <div className="p-3 border rounded">
              <i className="fas fa-handshake"></i>
              <p className="mt-2 text-sm">Collective Ledger</p>
            </div>
            <div className="p-3 border rounded">
              <i className="fas fa-chart-pie"></i>
              <p className="mt-2 text-sm">Profit Sharing</p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-black text-white p-4" ref={pdfRef}>
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">
          <i className="fas fa-shield-alt mr-2"></i>UdyamTrust
        </h1>
        <button
          onClick={downloadPDF}
          className="text-xs border px-3 py-1 rounded"
        >
          <i className="fas fa-download mr-1"></i>PDF
        </button>
      </div>

      {/* Tabs */}
      <div className="grid grid-cols-4 gap-1 mb-4 text-xs">
        {["Ledger", "Proof", "Family", "Community"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`py-2 rounded ${
              activeTab === tab ? "bg-white text-black" : "border"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="p-3 border rounded">{renderTabContent()}</div>
    </div>
  );
}
